<template>
    <vx-expandable-card>
        <template v-slot:header>HubSpot Company ID</template>
        <template v-if="loading" v-slot:content>
            <page-loading class="py-8"></page-loading>
        </template>
        <template v-else v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <hubspot-company-id-input
                    v-model="hubspotCompanyIdModel"
                    placeholder="HubSpot Company ID"
                    size="lg"
                    :disabled="!isEditable"
                    :error="displayFirstError($externalResults.hubspot_company_id)"
                />

                <vx-button v-if="isEditable" size="lg" @click.prevent="submit" :loading="submitting">
                    Update
                </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxButton } from '@voxie/frontend-components';
import HubspotCompanyIdInput from '~/components/general/HubspotCompanyIdInput.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { onMounted, ref } from 'vue';
import { adminGroupsClient } from '~/services';
import { displayFirstError } from '~/utils/validation';
import { useToasted } from '~/composables/useToasted';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
    isEditable: {
        type: Boolean,
        default: true,
    },
});

const toasted = useToasted();
const { $externalResults, catchError } = useFormRequestHandler();
const loading = ref(true);
const submitting = ref(false);
const hubspotCompanyIdModel = ref(null);

onMounted(async () => {
    try {
        const response = await adminGroupsClient.getHubspotCompanyId(props.teamId, props.groupId);
        hubspotCompanyIdModel.value = response.data.hubspot_company_id;
    } catch (e) {
        console.error(e);
        catchError(e);
    } finally {
        loading.value = false;
    }
});

const submit = async () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;
    $externalResults.value = {};

    try {
        await adminGroupsClient.updateHubspotCompanyId(props.teamId, props.groupId, {
            hubspot_company_id: hubspotCompanyIdModel.value,
        });

        toasted.success('HubSpot Company ID updated successfully');
    } catch (e) {
        catchError(e);
    } finally {
        submitting.value = false;
    }
};
</script>
